import React from 'react'

import { Button } from '@wartek-id/button-v1'
import {
  Dialog,
  DialogCloseButton,
  DialogContent,
  DialogHeader,
  DialogOverlay,
} from '@wartek-id/dialog-v1'

import SearchFilterBody from 'app/SearchPage/components/SearchFilterBody'
import { useSearchFilterState } from 'app/SearchPage/hooks/useSearchFilterState'

const SearchFilterDialog = ({ isOpen, onClose }) => {
  const {
    selectedFormats,
    setSelectedFormats,
    selectedTopics,
    setSelectedTopics,
    hasAnyFilterSelected,
    submitFilterHandler,
    resetFilterHandler,
    clickOptionHandler,
    searchFiltersData,
  } = useSearchFilterState({ isOpen, onClose })

  return (
    <Dialog isOpen={isOpen} onClose={onClose} size="lg">
      <DialogOverlay />
      <DialogContent>
        <DialogHeader title="Pilih kategori" />
        <DialogCloseButton onClick={onClose} />
        <div className="overflow-y-auto max-h-[60vh] px-4 py-2">
          <SearchFilterBody
            selectedFormats={selectedFormats}
            selectedTopics={selectedTopics}
            onFormatsChange={setSelectedFormats}
            onTopicsChange={setSelectedTopics}
            onCheckboxChange={clickOptionHandler}
            searchFiltersData={searchFiltersData}
          />
        </div>
        <div className="p-4 pt-2 flex gap-2">
          <Button
            color="white"
            fullWidth
            disabled={!hasAnyFilterSelected}
            onClick={resetFilterHandler}
          >
            Reset
          </Button>
          <Button color="blue" fullWidth onClick={submitFilterHandler}>
            Terapkan hasil
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default SearchFilterDialog
